export const preventDefaultBehavior = (event) => {
  event.preventDefault();
  event.stopPropagation();
};
